import React from 'react';
import { NavLink } from 'react-router-dom';
import GoogleTranslate from './GoogleTranslate';
export const SellerNav = () => {
  return (
    <section className="car-details">
      <header className="py-3">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light p-0">
            <a className="navbar-brand" href="https://carchaser.ca/">
              <img src="../images/logo.png" alt="logo-img" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
                                <ul className="navbar-nav">
                                <li className="nav-item dropdown">
                                    <NavLink className="nav-link" activeClassName="active" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Upcoming Cars
                                    </NavLink>
                                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
  <li>
    <NavLink
      className={({ isActive }) =>
        `dropdown-item ${
          sessionStorage.getItem("car_type") === "BuyNow" ? "active" : ""
        }`
      }
      to="/future-cars"
      onClick={() => sessionStorage.setItem("car_type", "BuyNow")}
    >
      Buy Now Cars
    </NavLink>
  </li>
  <li>
    <NavLink
      className={({ isActive }) =>
        `dropdown-item ${
          sessionStorage.getItem("car_type") === "Auction" ? "active" : ""
        }`
      }
      to="/future-cars"
      onClick={() => sessionStorage.setItem("car_type", "Auction")}
    >
      Auction Cars
    </NavLink>
  </li>
</ul>


                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" activeClassName="active" to="/buy-now">
                  Buy Now
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" activeClassName="active" to="/open-bid">
                  Live Auction
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" activeClassName="active" to="/nagition-cars">
                  Cars in Negotiation
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" activeClassName="active" to="/winner-bid">
                  My Garage
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" activeClassName="active" to="/WatchList">
                  Watch List
                  </NavLink>
                </li>
              </ul>
            </div>
            <div class="translate-panel">
          <GoogleTranslate />
          </div>
            <div className="signout-btn">
              <a href="/" className="btn btn-primary">
                Sign Out
              </a>
            </div>
          </nav>
        </div>
      </header>
    </section>
  );
};
